﻿/*
 * Fairyglim Bewegung beim Scrollen, bewusst ruhig und billig für den Prozessor:
 *  - nur das Startbild wächst beim Scrollen leicht (94 % auf 102 %), ohne Layout-Abfragen, nur ein transform
 *  - alles andere erscheint durch weiches Einblenden (CSS), ohne Verschieben
 * Mit "weniger Bewegung" im Betriebssystem passiert nichts davon.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  var art = document.querySelector('.fgh-hero .fgh-art');
  if (!art) return;
  document.documentElement.classList.add('fgh-motion');
  var vh = window.innerHeight || 800;
  var ticking = false, last = -1;
  function frame() {
    ticking = false;
    var y = window.pageYOffset || 0;
    var p = y >= vh ? 1 : y / vh;
    p = Math.round(p * 200) / 200;
    if (p === last) return;
    last = p;
    var eased = 1 - Math.pow(1 - p, 2);
    art.style.transform = 'scale(' + (0.94 + 0.08 * eased).toFixed(3) + ')';
  }
  function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', function () { vh = window.innerHeight || vh; schedule(); }, { passive: true });
  schedule();
})();
